import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { globalServices } from "../../Services/global.service";
import { posServices } from "../../Services/pos.service";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import Tooltip from "../Common/Tooltip";
import ResultModal from "../Common/ResultModal";
import { posTag } from "../../Config/Regex";
import { validationService } from "../../Services/validation.service";

const SwitchPos = ({
  show,
  handleHide,
  posId,
  tag,
  documentNumber,
  tenantId,
}) => {
  const history = useHistory();
  const { t: translator } = useTranslation();
  const [filteredStores, setFilteredStores] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [posIdRes, setPosIdRes] = useState(null);
  const { register, handleSubmit, errors, formState } = useForm();

  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    history.push(`/pos/${posIdRes}`);
  };

  useEffect(() => {
    posServices
      .getById(posId)
      .then((res) => {
        let posStore = res.data.storeId;
        globalServices
          .getStoresByTenantId(res.data.tenantId)
          .then((res) => {
            setFilteredStores(res.data.filter((s) => s.id !== posStore));
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  }, []);

  const confirmSwitch = (data) => {
    setIsLoading(true);
    handleHide();

    posServices
      .transferPos(
        Number(posId),
        Number(data.storeId),
        data.tag,
        Number(data.documentNumber)
      )
      .then((res) => {
        setIsLoading(false);
        setPosIdRes(Number(res.data.posId));

        res.data.success
          ? setResultModal({
              show: true,
              title: translator("SwitchPOS-Update-SuccessModal-Title"),
              text: translator("SwitchPOS-Update-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setResultModal({
              show: true,
              title: translator("SwitchPOS-Update-UnsuccessModal-Title"),
              text: translator("SwitchPOS-Update-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Modal show={show} onHide={handleHide} centered>
        <Modal.Header>
          <Modal.Title>{translator("PosDetail-SwitchPos")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {filteredStores.length !== 0 ? (
            <div className="container">
              <label>{translator("POS-List-Store")}</label>
              <select
                ref={register({ required: true })}
                className="form-control"
                defaultValue={0}
                name="storeId"
              >
                <option value="">{translator("Select-Store")}</option>
                {filteredStores.map((store) => {
                  return (
                    <option key={store.id} value={store.id}>
                      {store.name}
                    </option>
                  );
                })}
              </select>
              {errors.storeId && errors.storeId.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              <br />
              <label htmlFor="footerNote">
                {translator("POS-List-Tag")}
              </label>{" "}
              <Tooltip text={translator("POSSwitch-Tag-Msg")} />
              <input
                type="text"
                className="form-control"
                name="tag"
                ref={register({
                  required: true,
                  pattern: posTag,
                })}
                defaultValue={tag ? tag : ""}
              />
              {errors.tag && (
                <>
                  {errors.tag.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                  {errors.tag.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-PosTag")}
                    </p>
                  )}
                </>
              )}
              <br />
              <label htmlFor="footerNote">
                {translator("POS-New_EditPOS-DocumentNumber")}
              </label>{" "}
              <Tooltip text={translator("POS-DocNum-Msg")} />
              <input
                type="text"
                className="form-control"
                name="documentNumber"
                ref={register({ required: true })}
                defaultValue={documentNumber ? documentNumber : ""}
              />
              {errors.documentNumber && (
                <>
                  {errors.documentNumber.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </>
              )}
            </div>
          ) : (
            <div
              style={{ margin: 5, marginTop: "10px" }}
              className="alert alert-warning"
              role="alert"
            >
              {translator("NoExistingPosStore")}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-dismiss="modal"
            onClick={handleHide}
          >
            {translator("General-Close")}
          </button>
          {filteredStores.length !== 0 ? (
            <button
              onClick={handleSubmit(confirmSwitch)}
              type="button"
              className="btn btn-primary"
            >
              {translator("Btn-Switch")}
            </button>
          ) : (
            ""
          )}
        </Modal.Footer>
      </Modal>

      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
    </>
  );
};

export default SwitchPos;
